import { Icon, IconName, HelpIcon } from '@ardoq/icons';
import {
  DecoratorPlaceholder,
  DecoratorWrapper,
  getDecoratorIconSize,
} from './atoms';
import { normalizeColorToHex } from '@ardoq/color-helpers';

type ColorDecoratorProps = { color?: string; placeholder?: string };

export const ColorDecorator = ({ color, placeholder }: ColorDecoratorProps) => (
  <DecoratorWrapper>
    {color && (
      <>
        <Icon iconName={color as IconName} iconSize={getDecoratorIconSize()} />
        {normalizeColorToHex(color)}
      </>
    )}
    {!color && placeholder && (
      <>
        <HelpIcon iconSize={getDecoratorIconSize()} />
        <DecoratorPlaceholder>{placeholder}</DecoratorPlaceholder>
      </>
    )}
  </DecoratorWrapper>
);
